import { memo } from 'react';

import { useTranslations } from 'next-intl';

import { useFormField } from '@/components/ui/form';
import { cn } from '@/lib/utils/cn';

interface I_FormMessageProps {
  className?: string;
}

const FormMessage = memo(function FormMessage({
  className = ''
}: I_FormMessageProps) {
  const t = useTranslations('editProfile');
  const { error, formMessageId } = useFormField();

  if (!error) return null;

  const translationKey = error.message;

  // Simplified logic - just try to translate the key directly
  const translatedMessage = t(translationKey as string) || error.message;

  return (
    <p
      id={formMessageId}
      className={cn('text-destructive text-sm mt-1 ml-3', className)}
    >
      {translatedMessage}
    </p>
  );
});

FormMessage.displayName = 'FormMessage';

export default FormMessage;
